<header class="header" id="header">
  <div class="navbar header__userActions">
    <div class="navbar__mainLink">
      <a class="navbar-brand logoLink" routerLinkActive="router-link-active" id="Eccairs2HomeLinkHeader"
        title="SRIS2" (click)="redirectToHome()">
        <img src="assets/images/logo/SRIS.png" alt="European Central Repository Of Safety Recommendations"
          class="logoLink__image" />

        <h1 class="logoLink__text">European Central Repository Of Safety Recommendations</h1>
      </a>
    </div>
    <ul class="header__actionGroup">

      <li class="header__actionGroupItem" #advancedSearchAnchor>
        <form id="searchForm" [formGroup]="searchForm" (keydown)="keyDownFunction($event)">
          <mat-form-field appearance="outline" class="margin--smX">
            <input matInput type="text" placeholder="" id="searchInputTemplateHeader" formControlName="searchTerm"/>
            <span matSuffix mat-icon-button aria-label="Clear" *ngIf="showClearButton()" 
              class="search-clear-button" (click)="this.resetSearchForm()" disableRipple>
                <mat-icon class="custom-clear-icon">close</mat-icon>
            </span>
            <span class="search-search-button" matSuffix (click)="onSearchClick()">
              <img src="assets/images/icons/white/search.png" alt="search-icon" class="" />
            </span>
          </mat-form-field>
        </form>
      </li>
      <li class="header__actionGroupItem dp--inlineFlex alignItems--center flexDirection--row">
        <ng-select id="languageSelectHeader" [(ngModel)]="selectedLang" [disabled]="true">
          <ng-option *ngFor="let language of languages" [value]="language.id">{{language.name}}</ng-option>
        </ng-select>
      </li>
      <li class="header__actionGroupItem">
        <ul class="button__group">
          <li class="button__groupItem">
            <button class="iconButton--transparent " id="infoButtonHeader" matTooltip="Info" (click)="openInfoPDF()">
              <img src="assets/images/icons/white/info.png" alt="Info" class="ico--md" />
            </button>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</header>
